module.exports = __webpack_public_path__ + "img/mydz@2x.ce9df389.png";